const medicineBazarNp = {
  search: {
    placeholders: [
      'औषधिको नाम टाइप गर्नुहोस्...',
      'जेनेरिक नाम टाइप गर्नुहोस्...',
      'कम्पनीको नाम टाइप गर्नुहोस्...',
      'ब्रान्डको नाम टाइप गर्नुहोस्...',
      'फार्मेसी/स्टोरको नाम टाइप गर्नुहोस्...'
    ]
  },
  sidebar: {
    categoriesTitle: 'क्याटागोरी',
    storesTitle: 'फार्मेसीहरू'
  },
  upload: {
    title: 'प्रिस्क्रिप्सन अपलोड',
    subtitle: 'डाक्टरको प्रिस्क्रिप्सन अपलोड गरी सजिलै औषधि अर्डर गर्नुहोस्',
    uploadedPrefix: '✓ फाइल अपलोड भयो:',
    chooseFile: 'फाइल छान्नुहोस्',
    replaceFile: 'नयाँ फाइल अपलोड'
  },
  store: {
    serviceAreaLabel: 'सेवा क्षेत्र',
    nationwide: 'साराभरि',
    medicineCountLabel: 'औषधिहरू',
    close: 'बन्द गर्नुहोस्',
    productsOfSuffix: 'का औषधिहरू',
    descriptionPrefix: 'तल',
    descriptionSuffix: 'फार्मेसीका सबै उपलब्ध औषधिहरू देखाइएको छ। तपाईँ क्याटागोरी अनुसार फिल्टर गर्न सक्नुहुन्छ।'
  },
  card: {
    addToCart: 'झोलिमा राख्नुहोस्'
  },
  empty: {
    title: 'कुनै औषधि फेला परेन',
    subtitle: 'कृपया अर्को क्याटागोरी वा फार्मेसी छान्नुहोस्'
  },
  prescriptionFlow: {
    successTitle: 'प्रिस्क्रिप्सन सफलतापूर्वक अपलोड भयो!',
    instruction: 'औषधि अर्डरका लागि तलका विवरणहरू भर्नुहोस्',
    step1: {
      title: 'फार्मेसी छान्नुहोस्',
      subtitle: 'कुन फार्मेसीबाट किन्न चाहनुहुन्छ?',
      next: 'अर्को'
    },
    step2: {
      title: 'कोर्सको अवधि छान्नुहोस्',
      subtitle: 'कति दिनको लागि औषधि चाहिन्छ?',
      fullCourse: 'पूरा कोर्स',
      fiveDays: '५ दिनका लागि',
      tenDays: '१० दिनका लागि',
      customDays: 'कस्टम दिन',
      customDaysLabel: 'कति दिन?',
      customDaysPlaceholder: 'जस्तै: १५',
      back: 'पछाडि',
      next: 'अर्को'
    },
    step3: {
      title: 'अर्डर पुष्टि गर्नुहोस्',
      summaryTitle: 'तपाईंको अर्डर सारांश:',
      pharmacyLabel: 'फार्मेसी',
      durationLabel: 'कोर्सको अवधि',
      prescriptionLabel: 'प्रिस्क्रिप्सन',
      back: 'पछाडि',
      confirm: 'अर्डर पुष्टि गर्नुहोस्'
    },
    snackbar: {
      successTitle: '🎉 अर्डर सफलतापूर्वक पठाइयो!',
      message: 'तपाईंले छानेको फार्मेसीले चाँडै नै मूल्य र विवरणका साथ सम्पर्क गर्नेछ।'
    }
  }
};

export default medicineBazarNp;


